export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";